export default "__VITE_ASSET__d6a13cf8__"